import { render, staticRenderFns } from "./MastersMail.vue?vue&type=template&id=c2243074&scoped=true"
import script from "./MastersMail.vue?vue&type=script&lang=ts"
export * from "./MastersMail.vue?vue&type=script&lang=ts"
import style0 from "./MastersMail.vue?vue&type=style&index=0&id=c2243074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2243074",
  null
  
)

export default component.exports